export default "__VITE_ASSET__WOAlbmuS__"